import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import LogInButton from 'flarum/forum/components/LogInButton';
import extractText from 'flarum/common/utils/extractText';
import Tooltip from 'flarum/common/components/Tooltip';
import { openOAuthPopup } from '../utils/popupUtils';
export default function () {
  extend(LogInButton, 'initAttrs', function (_returnedValue, attrs) {
    attrs.onclick = function () {
      // Used to show a loading state in the Security page.
      if (attrs.provider) app.fof_oauth_linkingProvider = attrs.provider;
      openOAuthPopup(app, attrs);
    };
  });
  extend(LogInButtons.prototype, 'items', function (items) {
    var _app$forum$attribute$, _app$forum$attribute;
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    const enabledOAuthProviders = (_app$forum$attribute$ = (_app$forum$attribute = app.forum.attribute('fof-oauth')) == null ? void 0 : _app$forum$attribute.filter(provider => provider !== null)) != null ? _app$forum$attribute$ : [];
    enabledOAuthProviders.forEach(_ref => {
      let {
        name,
        icon,
        priority
      } = _ref;
      let className = "Button FoFLogInButton LogInButton--".concat(name);
      if (onlyIcons) {
        className += ' Button--icon';
      }
      items.add(name, m("div", {
        className: "LogInButtonContainer LogInButtonContainer--".concat(name)
      }, m(LogInButton, {
        className: className,
        icon: icon,
        path: "/auth/".concat(name),
        disabled: app.fof_oauth_loginInProgress
      }, app.translator.trans("fof-oauth.forum.log_in.with_".concat(name, "_button"), {
        provider: app.translator.trans("fof-oauth.forum.providers.".concat(name))
      }))), priority);
    });
  });
  override(LogInButton.prototype, 'view', function (original, vnode) {
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    if (!onlyIcons) return original(vnode);
    const child = original(vnode);

    // @ts-ignore
    return m(Tooltip, {
      text: extractText(child.children[1])
    }, child);
  });
  extend(LogInButtons.prototype, 'view', function (vdom) {
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    if (!onlyIcons) return;

    // @ts-ignore
    vdom.attrs.className += ' FoFLogInButtons--icons';
  });
  extend(app, 'authenticationComplete', function (_, payload) {
    if (payload.loggedIn) {
      app.fof_oauth_loginInProgress = true;
      // This will automatically be reset, as authenticationComplete also triggers a window reload.

      m.redraw();
    }
  });
  app.linkingComplete = async function () {
    try {
      var _app$session;
      app.fof_oauth_linkingInProgress = true;
      m.redraw();

      // Refresh the list of providers
      const newProviders = await this.store.find('linked-accounts');

      // Get the old IDs of the new providers (the one(s) that have just been linked)
      const newProviderOldIds = newProviders.filter(p => p.identifier() !== null).map(p => "".concat(app.session.user.id(), "-").concat(p.name()));

      // The store will contain an old version of the login provider (unlinked) that has
      // another ID than the new one (linked). We need to delete that one from the store
      // so that the UI gets updated correctly.

      // Find the old providers (match the old ID format: <userId>-<providerName>)
      const oldProviders = newProviderOldIds.map(oldId => this.store.getById('linked-accounts', oldId)).filter(p => !!p);
      if (oldProviders.length) {
        for (const oldProvider of oldProviders) {
          // @ts-ignore
          delete this.store.data['linked-accounts'][oldProvider.id()];
        }
      } else {
        // This may just be a signup/login flow, so reload the page to sign in the user.
        window.location.reload();
        return;
      }
      const userId = (_app$session = app.session) == null || (_app$session = _app$session.user) == null ? void 0 : _app$session.id();
      if (!userId) throw new Error('User ID not available');

      // Refresh the session user
      await this.store.find('users', userId);
      app.fof_oauth_linkingInProgress = false;
      m.redraw();
    } catch (error) {
      console.error('An error occurred while refreshing linked accounts after OAuth linking:', error);
      app.fof_oauth_linkingInProgress = false;
      m.redraw();
    }
  };
  extend('flarum/forum/components/LogInModal', 'onbeforeupdate', function () {
    if (app.fof_oauth_loginInProgress) {
      // @ts-ignore
      this.loading = true;
    }
  });
  extend('flarum/forum/components/SignUpModal', 'onbeforeupdate', function () {
    if (app.fof_oauth_loginInProgress) {
      // @ts-ignore
      this.loading = true;
    }
  });
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    // If a suggested username was not provided by the OAuth service, display some help text to the user.
    if (!!this.attrs.token && !this.attrs.username) {
      items.add('username-help', m("div", null, m("p", null, app.translator.trans('fof-oauth.forum.signup.username_help'))), 35);
    }
  });
}